import React  from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import cn from 'classnames';
import { Modal } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import Button from '../ui/Button';
import { dismissAll } from '../../actions/messageDialog';
import {
  MESSAGE_DIALOG_TYPE_ERROR,
  MESSAGE_DIALOG_TYPE_INFO_INTL,
  MESSAGE_DIALOG_TYPE_ERROR_INTL,
  MESSAGE_DIALOG_TYPE_DISCLAIMER,
} from '../../constants/messageDialogTypes';

const mapStateToProps = state => ({
  messageDialog: state.messageDialog,
});

const mapDispatchToProps = dispatch => ({
  dismissAllDispatch: () => dispatch(dismissAll()),
});

const renderMessageRow = (messageDialogMessage, index, intl) => {
  let typeClass = 'message-dialog__row--';
  if (messageDialogMessage.type === (MESSAGE_DIALOG_TYPE_ERROR || MESSAGE_DIALOG_TYPE_ERROR_INTL)) {
    typeClass += 'error';
  } else {
    typeClass += 'info';
  }
  let message;
  switch (messageDialogMessage.type) {
    case MESSAGE_DIALOG_TYPE_INFO_INTL:
    case MESSAGE_DIALOG_TYPE_ERROR_INTL:
      message = intl.formatMessage({ id: messageDialogMessage.message });
      break;
    case MESSAGE_DIALOG_TYPE_DISCLAIMER:
      message = { __html: messageDialogMessage.message };
      break;
    default:
      message = messageDialogMessage.message;
      break;
  }

  return (
    <li
      key={index}
      className={`message-dialog__row ${typeClass}`}
    >
      {messageDialogMessage.type === MESSAGE_DIALOG_TYPE_DISCLAIMER ?
        <div dangerouslySetInnerHTML={message} />
        : message}
    </li>
  );
};

const MessageDialog = ({ messageDialog, dismissAllDispatch, intl }) => (
  <div className="message-dialog">
    <Modal
      show={messageDialog.get('messageList').count() > 0}
      dialogClassName={cn('message-dialog__overlay', {
        'message-dialog__overlay--edit': true,
      })}
      style={{ opacity: 1 }}
    >
      <button
        onClick={dismissAllDispatch}
        className="message-dialog__close-button"
      />

      <div className="message-dialog__body">
        <ul>
          {
            messageDialog.get('messageList')
              .map((messageDialogMessage, i) => renderMessageRow(messageDialogMessage, i, intl))
          }
        </ul>
        <Button primary onClick={dismissAllDispatch}>
          <FormattedMessage id='messageDialog.dismissAllButton' />
        </Button>
      </div>
    </Modal>
  </div>
);

MessageDialog.propTypes = {
  messageDialog: PropTypes.instanceOf(Map),
  dismissAllDispatch: PropTypes.func,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(MessageDialog));



// WEBPACK FOOTER //
// ./src/js/components/MessageDialog/index.jsx